import React from 'react';
import { largeNumberAbbreviatorWithDecimal } from '@frontend/utils/formatNumbers';
import { Tooltip, TooltipContent, TooltipTrigger } from '@frontend/shadcn/components/ui/tooltip';

interface IProps {
    title: string;
    value: number;
    secondaryValue?: number;
    currency?: string;
    widgetType?: 'currency' | 'count' | 'percentage';
}

function getDisplayValue(value: number, widgetType: 'currency' | 'count' | 'percentage' = 'currency'): string {
    if (widgetType === 'currency') {
        const abbr = largeNumberAbbreviatorWithDecimal(value);
        return `${abbr.value}${abbr.symbol}`;
    }
    if (widgetType === 'count') {
        const abbr = largeNumberAbbreviatorWithDecimal(value);
        return `${abbr.value}${abbr.symbol}`;
    }
    return value?.toString() ?? '';
}

export function SalesStatsCard({ title, value, secondaryValue, currency, widgetType = 'currency' }: IProps) {
    return (
      <div className="p-2 bg-primary-foreground rounded-xl border border-t-[3px] border-grey-2 flex flex-col gap-1">
        <p className="m-0 text-xs font-medium text-grey-6">{title}</p>
        <Tooltip>
          <TooltipTrigger asChild>
            <p className="m-0 text-base font-normal text-grey-6 cursor-pointer">
              {widgetType === 'currency' ? `$ ${getDisplayValue(value, widgetType)}` : getDisplayValue(value, widgetType)}
            </p>
          </TooltipTrigger>
          <TooltipContent className="bg-grey-0 text-grey-6 shadow-lg border border-gray-200 rounded-md px-3 py-2 font-medium z-50 max-w-[200px]">
            {widgetType === 'currency' ? value.toFixed(2) : value}
          </TooltipContent>
        </Tooltip>
        {secondaryValue && currency && (
        <p className="m-0 text-xs font-normal text-grey-6">{currency} {' '}{getDisplayValue(secondaryValue, widgetType)}</p>
            )}
      </div>
    );
}

export default SalesStatsCard;
